// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeAiPage — "See how AI fits a business like yours."
   Prefix: impac_ai_home_pg_ · no :root variables · no green
   ============================================================ */

.impac_ai_home_pg_section {
  width: 100%;
  padding: 72px 0 88px;
  background: linear-gradient(180deg, #efe9ff 0%, #f8f4ff 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  color: #0f0a2a;
  overflow: hidden;
}

.impac_ai_home_pg_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ---------- Section header ---------- */

.impac_ai_home_pg_head {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  text-align: center;
}

.impac_ai_home_pg_eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.impac_ai_home_pg_eyebrow::before,
.impac_ai_home_pg_eyebrow::after {
  content: "";
  width: 30px;
  height: 2px;
  border-radius: 2px;
  background: #f2a900;
  transform: scaleX(0);
  transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.3s;
}

.impac_ai_home_pg_eyebrow::before {
  transform-origin: right center;
}

.impac_ai_home_pg_eyebrow::after {
  transform-origin: left center;
}

.impac_ai_home_pg_title {
  max-width: 640px;
  margin: 0 0 14px;
  font-size: clamp(28px, 3.6vw, 44px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.015em;
  color: #0f0a2a;
  text-wrap: balance;
}

.impac_ai_home_pg_subtitle {
  max-width: 560px;
  margin: 0;
  font-size: 16px;
  line-height: 1.65;
  color: #5d5978;
  text-wrap: balance;
}

/* header + card scroll reveal */
.impac_ai_home_pg_eyebrow,
.impac_ai_home_pg_title,
.impac_ai_home_pg_subtitle,
.impac_ai_home_pg_card {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_ai_home_pg_title {
  transition-delay: 0.1s;
}

.impac_ai_home_pg_subtitle {
  transition-delay: 0.2s;
}

.impac_ai_home_pg_card {
  transform: translateY(40px) scale(0.98);
  transition-delay: 0.3s;
}

.impac_ai_home_pg_in .impac_ai_home_pg_eyebrow,
.impac_ai_home_pg_in .impac_ai_home_pg_title,
.impac_ai_home_pg_in .impac_ai_home_pg_subtitle,
.impac_ai_home_pg_in .impac_ai_home_pg_card {
  opacity: 1;
  transform: none;
}

.impac_ai_home_pg_in .impac_ai_home_pg_eyebrow::before,
.impac_ai_home_pg_in .impac_ai_home_pg_eyebrow::after {
  transform: scaleX(1);
}

/* ---------- Card ---------- */

.impac_ai_home_pg_card {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #e4dcf9;
  background: #ffffff;
  box-shadow: 0 28px 70px rgba(74, 26, 158, 0.14), 0 2px 8px rgba(74, 26, 158, 0.05);
}

/* ---------- Sidebar ---------- */

.impac_ai_home_pg_tabs {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-right: 1px solid #e4dcf9;
  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);
}

.impac_ai_home_pg_tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 11px 14px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  color: #1c1538;
  cursor: pointer;
  isolation: isolate;
  transition: color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}

/* purple fill that fades + scales in on the active tab */
.impac_ai_home_pg_tab::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: 12px;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  opacity: 0;
  transform: scale(0.92);
  transition: opacity 0.35s ease, transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.impac_ai_home_pg_tab:hover {
  transform: translateX(4px);
  background: rgba(106, 31, 194, 0.07);
}

.impac_ai_home_pg_tab_active,
.impac_ai_home_pg_tab_active:hover {
  transform: none;
  background: transparent;
  color: #ffffff;
  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.32);
}

.impac_ai_home_pg_tab_active::before {
  opacity: 1;
  transform: scale(1);
}

.impac_ai_home_pg_tab:focus-visible {
  outline: 3px solid #f2a900;
  outline-offset: 2px;
}

.impac_ai_home_pg_tab_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #f0e9ff;
  color: #5a1fb5;
  transition: background 0.3s ease, color 0.3s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.impac_ai_home_pg_tab_active .impac_ai_home_pg_tab_icon {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  transform: scale(1.08);
}

.impac_ai_home_pg_tab_label {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.impac_ai_home_pg_tab_num {
  font-size: 11.5px;
  font-weight: 800;
  color: #6b6784;
  transition: color 0.3s ease;
}

.impac_ai_home_pg_tab_active .impac_ai_home_pg_tab_num {
  color: #ffbf1f;
}

/* ---------- Detail panel ---------- */

.impac_ai_home_pg_detail {
  min-width: 0;
  padding: 34px 38px 38px;
  background: linear-gradient(135deg, #ffffff 0%, #fdf1ec 100%);
}

/* the zoom-out + fade that replays on every tab click */
.impac_ai_home_pg_panel {
  min-height: 440px;
  transform-origin: 30% 20%;
  animation: impac_ai_home_pg_zoom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes impac_ai_home_pg_zoom {
  from {
    opacity: 0;
    transform: scale(0.9);
    filter: blur(4px);
  }
  to {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}

/* each block inside the panel rises in, one after another */
.impac_ai_home_pg_step {
  animation: impac_ai_home_pg_rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--s, 0) * 70ms + 120ms);
}

@keyframes impac_ai_home_pg_rise {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.impac_ai_home_pg_panel_top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.impac_ai_home_pg_panel_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);
  color: #ffffff;
  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.3);
}

.impac_ai_home_pg_panel_icon svg {
  width: 22px;
  height: 22px;
}

.impac_ai_home_pg_panel_count {
  padding: 5px 12px;
  border-radius: 999px;
  background: #f0e9ff;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.impac_ai_home_pg_panel_heading {
  max-width: 640px;
  margin: 0 0 12px;
  font-size: clamp(24px, 2.7vw, 33px);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #0f0a2a;
  text-wrap: balance;
}

.impac_ai_home_pg_panel_desc {
  max-width: 560px;
  margin: 0 0 26px;
  font-size: 15.5px;
  line-height: 1.65;
  color: #5d5978;
}

/* ---------- Points + key result ---------- */

.impac_ai_home_pg_body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 250px;
  gap: 22px;
  align-items: start;
  margin-bottom: 28px;
}

.impac_ai_home_pg_helps_label {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.impac_ai_home_pg_points {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.impac_ai_home_pg_point {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 16px;
  border: 1px solid #e4dcf9;
  border-radius: 12px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  color: #1c1538;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.impac_ai_home_pg_point:hover {
  transform: translateX(5px);
  border-color: #c9b6f2;
  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.1);
}

.impac_ai_home_pg_point_num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #f2a900;
  font-size: 12px;
  font-weight: 800;
  color: #ffffff;
}

.impac_ai_home_pg_point_text {
  min-width: 0;
}

.impac_ai_home_pg_result {
  display: flex;
  flex-direction: column;
  padding: 20px 22px;
  border: 1px solid #e4dcf9;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(74, 26, 158, 0.08);
}

.impac_ai_home_pg_result_label {
  margin: 0 0 6px;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.impac_ai_home_pg_result_value {
  display: block;
  font-size: clamp(38px, 4vw, 52px);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: #3a14a0;
  font-variant-numeric: tabular-nums;
  min-height: 1.1em;
}

.impac_ai_home_pg_result_text {
  margin: 10px 0 16px;
  font-size: 12px;
  line-height: 1.5;
  color: #6b6784;
}

.impac_ai_home_pg_result_line {
  display: block;
  height: 1px;
  margin-bottom: 14px;
  background: #e4dcf9;
}

.impac_ai_home_pg_result_pill {
  align-self: flex-start;
  padding: 5px 11px;
  border-radius: 999px;
  background: #fdecc2;
  font-size: 11px;
  font-weight: 700;
  color: #6b4a00;
}

/* ---------- Buttons ---------- */

.impac_ai_home_pg_actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.impac_ai_home_pg_btn_dark,
.impac_ai_home_pg_btn_primary {
  position: relative;
  padding: 13px 24px;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 800;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}

.impac_ai_home_pg_btn_dark {
  background: #55024f;
  box-shadow: 0 10px 22px rgba(85, 2, 79, 0.28);
}

.impac_ai_home_pg_btn_primary {
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 12px 26px rgba(74, 26, 158, 0.34);
}

.impac_ai_home_pg_btn_dark:hover,
.impac_ai_home_pg_btn_primary:hover {
  transform: translateY(-3px);
  filter: brightness(1.1);
}

.impac_ai_home_pg_btn_dark:active,
.impac_ai_home_pg_btn_primary:active {
  transform: translateY(0) scale(0.97);
}

.impac_ai_home_pg_btn_dark:focus-visible,
.impac_ai_home_pg_btn_primary:focus-visible {
  outline: 3px solid #f2a900;
  outline-offset: 3px;
}

/* ============================================================
   Responsive — 1100 / 820 / 560
   ============================================================ */

@media (max-width: 1100px) {
  .impac_ai_home_pg_card {
    grid-template-columns: 240px minmax(0, 1fr);
  }

  .impac_ai_home_pg_detail {
    padding: 28px 28px 32px;
  }

  .impac_ai_home_pg_body {
    grid-template-columns: minmax(0, 1fr) 220px;
    gap: 18px;
  }
}

/* sidebar turns into a sideways-scrolling pill row */
@media (max-width: 820px) {
  .impac_ai_home_pg_section {
    padding: 56px 0 68px;
  }

  .impac_ai_home_pg_card {
    grid-template-columns: minmax(0, 1fr);
  }

  .impac_ai_home_pg_tabs {
    flex-direction: row;
    gap: 8px;
    padding: 12px;
    overflow-x: auto;
    border-right: 0;
    border-bottom: 1px solid #e4dcf9;
    scroll-snap-type: x proximity;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .impac_ai_home_pg_tabs::-webkit-scrollbar {
    display: none;
  }

  .impac_ai_home_pg_tab {
    width: auto;
    flex-shrink: 0;
    padding: 9px 14px 9px 10px;
    scroll-snap-align: center;
  }

  .impac_ai_home_pg_tab:hover {
    transform: none;
  }

  .impac_ai_home_pg_tab_num {
    display: none;
  }

  .impac_ai_home_pg_tab_label {
    overflow: visible;
  }

  .impac_ai_home_pg_panel {
    min-height: 0;
  }
}

/* single column content */
@media (max-width: 560px) {
  .impac_ai_home_pg_container {
    padding: 0 14px;
  }

  .impac_ai_home_pg_head {
    margin-bottom: 28px;
  }

  .impac_ai_home_pg_subtitle {
    font-size: 15px;
  }

  .impac_ai_home_pg_card {
    border-radius: 16px;
  }

  .impac_ai_home_pg_detail {
    padding: 22px 16px 26px;
  }

  .impac_ai_home_pg_panel_desc {
    margin-bottom: 22px;
    font-size: 15px;
  }

  .impac_ai_home_pg_body {
    grid-template-columns: minmax(0, 1fr);
    margin-bottom: 24px;
  }

  .impac_ai_home_pg_actions {
    flex-direction: column;
  }

  .impac_ai_home_pg_btn_dark,
  .impac_ai_home_pg_btn_primary {
    width: 100%;
    padding: 14px 20px;
  }
}

/* ---------- Reduced motion ---------- */

@media (prefers-reduced-motion: reduce) {
  .impac_ai_home_pg_eyebrow,
  .impac_ai_home_pg_title,
  .impac_ai_home_pg_subtitle,
  .impac_ai_home_pg_card,
  .impac_ai_home_pg_tab,
  .impac_ai_home_pg_tab::before,
  .impac_ai_home_pg_point {
    transition: opacity 0.2s ease !important;
    transform: none !important;
  }

  .impac_ai_home_pg_panel,
  .impac_ai_home_pg_step {
    animation: impac_ai_home_pg_fade_only 0.25s ease both !important;
    animation-delay: 0s !important;
  }

  @keyframes impac_ai_home_pg_fade_only {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}


/* ================= Impact explorer (Working Professionals) ================= */

/* ============================================================
   Impact explorer (Working Professionals) — shown inside HomeAiPage
   Prefix: impac_ai_home_pg_x_ · no :root variables · no green
   ============================================================ */

.impac_ai_home_pg_x_section {
  width: 100%;
  padding: 72px 0 80px;
  background: linear-gradient(180deg, #f8f4ff 0%, #f3edff 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  color: #0f0a2a;
  overflow: hidden;
}

.impac_ai_home_pg_x_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ---------- Header ---------- */

.impac_ai_home_pg_x_head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 36px;
}

.impac_ai_home_pg_x_eyebrow {
  margin-bottom: 14px;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.impac_ai_home_pg_x_title {
  max-width: 620px;
  margin: 0 0 14px;
  font-size: clamp(28px, 3.6vw, 44px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.015em;
  color: #0f0a2a;
  text-wrap: balance;
}

.impac_ai_home_pg_x_subtitle {
  max-width: 540px;
  margin: 0;
  font-size: 15.5px;
  line-height: 1.65;
  color: #5d5978;
}

/* scroll reveal */
.impac_ai_home_pg_x_eyebrow,
.impac_ai_home_pg_x_title,
.impac_ai_home_pg_x_subtitle,
.impac_ai_home_pg_x_card,
.impac_ai_home_pg_x_note {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.impac_ai_home_pg_x_title {
  transition-delay: 0.1s;
}

.impac_ai_home_pg_x_subtitle {
  transition-delay: 0.2s;
}

.impac_ai_home_pg_x_card {
  transform: translateY(40px) scale(0.98);
  transition-delay: 0.3s;
}

.impac_ai_home_pg_x_note {
  transition-delay: 0.6s;
}

.impac_ai_home_pg_x_in .impac_ai_home_pg_x_eyebrow,
.impac_ai_home_pg_x_in .impac_ai_home_pg_x_title,
.impac_ai_home_pg_x_in .impac_ai_home_pg_x_subtitle,
.impac_ai_home_pg_x_in .impac_ai_home_pg_x_card,
.impac_ai_home_pg_x_in .impac_ai_home_pg_x_note {
  opacity: 1;
  transform: none;
}

/* ---------- Card ---------- */

.impac_ai_home_pg_x_card {
  display: grid;
  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
  gap: 22px;
  align-items: start;
  padding: 22px;
  border-radius: 20px;
  border: 1px solid #e4dcf9;
  background: linear-gradient(135deg, #f8f4ff 0%, #fff4ee 100%);
  box-shadow: 0 28px 70px rgba(74, 26, 158, 0.12), 0 2px 8px rgba(74, 26, 158, 0.05);
}

/* ---------- List ---------- */

.impac_ai_home_pg_x_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.impac_ai_home_pg_x_item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 16px 10px 12px;
  border: 1px solid #e4dcf9;
  border-radius: 12px;
  background: #ffffff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  color: #1c1538;
  cursor: pointer;
  isolation: isolate;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

/* purple fill that fades + scales in on the active item */
.impac_ai_home_pg_x_item::before {
  content: "";
  position: absolute;
  inset: -1px;
  z-index: -1;
  border-radius: 12px;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  opacity: 0;
  transform: scale(0.94);
  transition: opacity 0.35s ease, transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.impac_ai_home_pg_x_item:hover {
  transform: translateX(4px);
  border-color: #c9b6f2;
  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.1);
}

.impac_ai_home_pg_x_item_active,
.impac_ai_home_pg_x_item_active:hover {
  transform: none;
  border-color: transparent;
  color: #ffffff;
  box-shadow: 0 16px 30px rgba(74, 26, 158, 0.34);
}

.impac_ai_home_pg_x_item_active::before {
  opacity: 1;
  transform: scale(1);
}

.impac_ai_home_pg_x_item:focus-visible {
  outline: 3px solid #f2a900;
  outline-offset: 2px;
}

.impac_ai_home_pg_x_item_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 9px;
  background: #f0e9ff;
  color: #5a1fb5;
  transition: background 0.3s ease, color 0.3s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.impac_ai_home_pg_x_item_icon svg {
  width: 18px;
  height: 18px;
}

.impac_ai_home_pg_x_item_active .impac_ai_home_pg_x_item_icon {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  transform: scale(1.08);
}

.impac_ai_home_pg_x_item_name {
  flex: 1 1;
  min-width: 0;
  line-height: 1.3;
}

.impac_ai_home_pg_x_item_value {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 800;
  color: #3a14a0;
  transition: color 0.3s ease;
}

.impac_ai_home_pg_x_item_active .impac_ai_home_pg_x_item_value {
  color: #ffbf1f;
}

/* ---------- Detail ---------- */

.impac_ai_home_pg_x_detail {
  min-width: 0;
  padding: 26px 28px 28px;
  border: 1px solid #e4dcf9;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);
}

/* zoom-out + fade that replays on every click */
.impac_ai_home_pg_x_panel {
  min-height: 420px;
  transform-origin: 30% 15%;
  animation: impac_ai_home_pg_x_zoom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes impac_ai_home_pg_x_zoom {
  from {
    opacity: 0;
    transform: scale(0.9);
    filter: blur(4px);
  }
  to {
    opacity: 1;
    transform: scale(1);
    filter: blur(0);
  }
}

/* each block rises in, one after another */
.impac_ai_home_pg_x_step {
  animation: impac_ai_home_pg_x_rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--s, 0) * 70ms + 120ms);
}

@keyframes impac_ai_home_pg_x_rise {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.impac_ai_home_pg_x_panel_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}

.impac_ai_home_pg_x_panel_label {
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.impac_ai_home_pg_x_panel_pill {
  padding: 4px 11px;
  border-radius: 999px;
  background: #fdecc2;
  font-size: 11px;
  font-weight: 700;
  color: #6b4a00;
}

.impac_ai_home_pg_x_figure {
  margin-bottom: 22px;
}

.impac_ai_home_pg_x_big {
  display: block;
  font-size: clamp(48px, 6.2vw, 80px);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: #3a14a0;
  font-variant-numeric: tabular-nums;
  min-height: 1.05em;
  overflow-wrap: anywhere;
}

.impac_ai_home_pg_x_unit {
  margin: 6px 0 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  color: #1c1538;
}

/* ---------- Before / after bars ---------- */

.impac_ai_home_pg_x_bars {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
  padding: 18px 20px;
  border: 1px solid #e4dcf9;
  border-radius: 14px;
  background: #ffffff;
}

.impac_ai_home_pg_x_bar_top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 7px;
  font-size: 12.5px;
}

.impac_ai_home_pg_x_bar_label {
  min-width: 0;
  color: #3d3858;
}

.impac_ai_home_pg_x_bar_value {
  flex-shrink: 0;
  font-weight: 800;
  color: #0f0a2a;
}

.impac_ai_home_pg_x_bar_value_accent {
  color: #4a1a9e;
}

.impac_ai_home_pg_x_track {
  height: 10px;
  border-radius: 10px;
  background: #f1ebfd;
  overflow: hidden;
}

.impac_ai_home_pg_x_fill {
  display: block;
  width: var(--w, 0%);
  height: 100%;
  border-radius: 10px;
  background: #d9ccf3;
  /* grows from 0 each time the panel is re-keyed */
  animation: impac_ai_home_pg_x_grow 1.1s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(0.45s + var(--b, 0) * 0.2s);
}

.impac_ai_home_pg_x_fill_accent {
  background: linear-gradient(90deg, #4a1a9e 0%, #6a1fc2 100%);
}

@keyframes impac_ai_home_pg_x_grow {
  from {
    width: 0;
  }
}

/* ---------- Text ---------- */

.impac_ai_home_pg_x_text {
  max-width: 620px;
  margin: 0 0 10px;
  font-size: 14.5px;
  line-height: 1.65;
  color: #1c1538;
}

.impac_ai_home_pg_x_source {
  margin: 0 0 22px;
  font-size: 11.5px;
  line-height: 1.5;
  color: #6b6784;
}

.impac_ai_home_pg_x_btn {
  padding: 13px 24px;
  border: 0;
  border-radius: 8px;
  background: #55024f;
  box-shadow: 0 10px 22px rgba(85, 2, 79, 0.28);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 800;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}

.impac_ai_home_pg_x_btn:hover {
  transform: translateY(-3px);
  filter: brightness(1.12);
  box-shadow: 0 14px 28px rgba(85, 2, 79, 0.34);
}

.impac_ai_home_pg_x_btn:active {
  transform: translateY(0) scale(0.97);
}

.impac_ai_home_pg_x_btn:focus-visible {
  outline: 3px solid #f2a900;
  outline-offset: 3px;
}

.impac_ai_home_pg_x_note {
  margin: 14px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #6b6784;
}

/* ============================================================
   Responsive — 1100 / 820 / 560
   ============================================================ */

@media (max-width: 1100px) {
  .impac_ai_home_pg_x_card {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 18px;
    padding: 18px;
  }

  .impac_ai_home_pg_x_detail {
    padding: 22px 22px 24px;
  }

  .impac_ai_home_pg_x_item {
    font-size: 13.5px;
  }
}

/* list becomes a sideways-scrolling row above the detail */
@media (max-width: 820px) {
  .impac_ai_home_pg_x_section {
    padding: 56px 0 64px;
  }

  .impac_ai_home_pg_x_card {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  .impac_ai_home_pg_x_list {
    flex-direction: row;
    gap: 8px;
    margin: 0 -4px;
    padding: 4px 4px 10px;
    overflow-x: auto;
    scroll-snap-type: x proximity;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .impac_ai_home_pg_x_list::-webkit-scrollbar {
    display: none;
  }

  .impac_ai_home_pg_x_item {
    width: auto;
    flex-shrink: 0;
    gap: 10px;
    padding: 9px 14px 9px 10px;
    white-space: nowrap;
    scroll-snap-align: center;
  }

  .impac_ai_home_pg_x_item:hover {
    transform: none;
  }

  .impac_ai_home_pg_x_panel {
    min-height: 0;
  }
}

@media (max-width: 560px) {
  .impac_ai_home_pg_x_container {
    padding: 0 14px;
  }

  .impac_ai_home_pg_x_head {
    margin-bottom: 26px;
  }

  .impac_ai_home_pg_x_subtitle {
    font-size: 15px;
  }

  .impac_ai_home_pg_x_card {
    padding: 12px;
    border-radius: 16px;
  }

  .impac_ai_home_pg_x_detail {
    padding: 18px 16px 22px;
    border-radius: 14px;
  }

  .impac_ai_home_pg_x_bars {
    padding: 14px 14px;
  }

  .impac_ai_home_pg_x_bar_top {
    font-size: 12px;
  }

  .impac_ai_home_pg_x_btn {
    width: 100%;
    padding: 14px 20px;
  }
}

/* ---------- Reduced motion ---------- */

@media (prefers-reduced-motion: reduce) {
  .impac_ai_home_pg_x_eyebrow,
  .impac_ai_home_pg_x_title,
  .impac_ai_home_pg_x_subtitle,
  .impac_ai_home_pg_x_card,
  .impac_ai_home_pg_x_note,
  .impac_ai_home_pg_x_item,
  .impac_ai_home_pg_x_item::before {
    transition: opacity 0.2s ease !important;
    transform: none !important;
  }

  .impac_ai_home_pg_x_panel,
  .impac_ai_home_pg_x_step,
  .impac_ai_home_pg_x_fill {
    animation: impac_ai_home_pg_x_fade_only 0.25s ease both !important;
    animation-delay: 0s !important;
  }

  @keyframes impac_ai_home_pg_x_fade_only {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}


/* ---- header tab switch: whole section fades + rises in ---- */
.impac_ai_home_pg_swap {
  animation: impac_ai_home_pg_swap_in 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes impac_ai_home_pg_swap_in {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .impac_ai_home_pg_swap {
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeAiPage/HomeAiPage.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;;;;EAIE,UAAU;EACV,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;;;;EAIE,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sEAAsE;AACxE;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,UAAU;EACV,sBAAsB;EACtB,iFAAiF;AACnF;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mGAAmG;AACrG;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,YAAY;EACZ,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,0EAA0E;AAC5E;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,4DAA4D;AAC5D;EACE,yEAAyE;EACzE,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,6EAA6E;AAC/E;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;IAC3C,SAAS;EACX;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;;AAEzC;EACE;;;;;;;IAOE,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;;IAEE,gEAAgE;IAChE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;AACF;;;AAGA,gFAAgF;;AAEhF;;;iEAGiE;;AAEjE;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;;;EAKE,UAAU;EACV,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;EAKE,UAAU;EACV,eAAe;AACjB;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,kFAAkF;AACpF;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,UAAU;EACV,sBAAsB;EACtB,iFAAiF;AACnF;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mGAAmG;AACrG;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;;AAEjC;EACE,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4EAA4E;AAC9E;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE,2EAA2E;EAC3E,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,2EAA2E;EAC3E,iDAAiD;AACnD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,wDAAwD;IACxD,SAAS;IACT,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;IACd,SAAS;IACT,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;;AAEzC;EACE;;;;;;;IAOE,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;;;IAGE,kEAAkE;IAClE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;AACF;;;AAGA,gEAAgE;AAChE;EACE,4EAA4E;AAC9E;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   HomeAiPage — \"See how AI fits a business like yours.\"\n   Prefix: impac_ai_home_pg_ · no :root variables · no green\n   ============================================================ */\n\n.impac_ai_home_pg_section {\n  width: 100%;\n  padding: 72px 0 88px;\n  background: linear-gradient(180deg, #efe9ff 0%, #f8f4ff 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  color: #0f0a2a;\n  overflow: hidden;\n}\n\n.impac_ai_home_pg_container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ---------- Section header ---------- */\n\n.impac_ai_home_pg_head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.impac_ai_home_pg_eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 14px;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_eyebrow::before,\n.impac_ai_home_pg_eyebrow::after {\n  content: \"\";\n  width: 30px;\n  height: 2px;\n  border-radius: 2px;\n  background: #f2a900;\n  transform: scaleX(0);\n  transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.3s;\n}\n\n.impac_ai_home_pg_eyebrow::before {\n  transform-origin: right center;\n}\n\n.impac_ai_home_pg_eyebrow::after {\n  transform-origin: left center;\n}\n\n.impac_ai_home_pg_title {\n  max-width: 640px;\n  margin: 0 0 14px;\n  font-size: clamp(28px, 3.6vw, 44px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.015em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n.impac_ai_home_pg_subtitle {\n  max-width: 560px;\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.65;\n  color: #5d5978;\n  text-wrap: balance;\n}\n\n/* header + card scroll reveal */\n.impac_ai_home_pg_eyebrow,\n.impac_ai_home_pg_title,\n.impac_ai_home_pg_subtitle,\n.impac_ai_home_pg_card {\n  opacity: 0;\n  transform: translateY(26px);\n  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_ai_home_pg_title {\n  transition-delay: 0.1s;\n}\n\n.impac_ai_home_pg_subtitle {\n  transition-delay: 0.2s;\n}\n\n.impac_ai_home_pg_card {\n  transform: translateY(40px) scale(0.98);\n  transition-delay: 0.3s;\n}\n\n.impac_ai_home_pg_in .impac_ai_home_pg_eyebrow,\n.impac_ai_home_pg_in .impac_ai_home_pg_title,\n.impac_ai_home_pg_in .impac_ai_home_pg_subtitle,\n.impac_ai_home_pg_in .impac_ai_home_pg_card {\n  opacity: 1;\n  transform: none;\n}\n\n.impac_ai_home_pg_in .impac_ai_home_pg_eyebrow::before,\n.impac_ai_home_pg_in .impac_ai_home_pg_eyebrow::after {\n  transform: scaleX(1);\n}\n\n/* ---------- Card ---------- */\n\n.impac_ai_home_pg_card {\n  display: grid;\n  grid-template-columns: 280px minmax(0, 1fr);\n  overflow: hidden;\n  border-radius: 20px;\n  border: 1px solid #e4dcf9;\n  background: #ffffff;\n  box-shadow: 0 28px 70px rgba(74, 26, 158, 0.14), 0 2px 8px rgba(74, 26, 158, 0.05);\n}\n\n/* ---------- Sidebar ---------- */\n\n.impac_ai_home_pg_tabs {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px;\n  border-right: 1px solid #e4dcf9;\n  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);\n}\n\n.impac_ai_home_pg_tab {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 11px 14px;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: left;\n  color: #1c1538;\n  cursor: pointer;\n  isolation: isolate;\n  transition: color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* purple fill that fades + scales in on the active tab */\n.impac_ai_home_pg_tab::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  border-radius: 12px;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  opacity: 0;\n  transform: scale(0.92);\n  transition: opacity 0.35s ease, transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.impac_ai_home_pg_tab:hover {\n  transform: translateX(4px);\n  background: rgba(106, 31, 194, 0.07);\n}\n\n.impac_ai_home_pg_tab_active,\n.impac_ai_home_pg_tab_active:hover {\n  transform: none;\n  background: transparent;\n  color: #ffffff;\n  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.32);\n}\n\n.impac_ai_home_pg_tab_active::before {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.impac_ai_home_pg_tab:focus-visible {\n  outline: 3px solid #f2a900;\n  outline-offset: 2px;\n}\n\n.impac_ai_home_pg_tab_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #f0e9ff;\n  color: #5a1fb5;\n  transition: background 0.3s ease, color 0.3s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.impac_ai_home_pg_tab_active .impac_ai_home_pg_tab_icon {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  transform: scale(1.08);\n}\n\n.impac_ai_home_pg_tab_label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.impac_ai_home_pg_tab_num {\n  font-size: 11.5px;\n  font-weight: 800;\n  color: #6b6784;\n  transition: color 0.3s ease;\n}\n\n.impac_ai_home_pg_tab_active .impac_ai_home_pg_tab_num {\n  color: #ffbf1f;\n}\n\n/* ---------- Detail panel ---------- */\n\n.impac_ai_home_pg_detail {\n  min-width: 0;\n  padding: 34px 38px 38px;\n  background: linear-gradient(135deg, #ffffff 0%, #fdf1ec 100%);\n}\n\n/* the zoom-out + fade that replays on every tab click */\n.impac_ai_home_pg_panel {\n  min-height: 440px;\n  transform-origin: 30% 20%;\n  animation: impac_ai_home_pg_zoom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes impac_ai_home_pg_zoom {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n    filter: blur(4px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n    filter: blur(0);\n  }\n}\n\n/* each block inside the panel rises in, one after another */\n.impac_ai_home_pg_step {\n  animation: impac_ai_home_pg_rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: calc(var(--s, 0) * 70ms + 120ms);\n}\n\n@keyframes impac_ai_home_pg_rise {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.impac_ai_home_pg_panel_top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.impac_ai_home_pg_panel_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  flex-shrink: 0;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);\n  color: #ffffff;\n  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.3);\n}\n\n.impac_ai_home_pg_panel_icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.impac_ai_home_pg_panel_count {\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: #f0e9ff;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_panel_heading {\n  max-width: 640px;\n  margin: 0 0 12px;\n  font-size: clamp(24px, 2.7vw, 33px);\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n.impac_ai_home_pg_panel_desc {\n  max-width: 560px;\n  margin: 0 0 26px;\n  font-size: 15.5px;\n  line-height: 1.65;\n  color: #5d5978;\n}\n\n/* ---------- Points + key result ---------- */\n\n.impac_ai_home_pg_body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 250px;\n  gap: 22px;\n  align-items: start;\n  margin-bottom: 28px;\n}\n\n.impac_ai_home_pg_helps_label {\n  margin: 0 0 12px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_points {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.impac_ai_home_pg_point {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 13px 16px;\n  border: 1px solid #e4dcf9;\n  border-radius: 12px;\n  background: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.45;\n  color: #1c1538;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.impac_ai_home_pg_point:hover {\n  transform: translateX(5px);\n  border-color: #c9b6f2;\n  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.1);\n}\n\n.impac_ai_home_pg_point_num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #f2a900;\n  font-size: 12px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.impac_ai_home_pg_point_text {\n  min-width: 0;\n}\n\n.impac_ai_home_pg_result {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 22px;\n  border: 1px solid #e4dcf9;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 14px 30px rgba(74, 26, 158, 0.08);\n}\n\n.impac_ai_home_pg_result_label {\n  margin: 0 0 6px;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_result_value {\n  display: block;\n  font-size: clamp(38px, 4vw, 52px);\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  color: #3a14a0;\n  font-variant-numeric: tabular-nums;\n  min-height: 1.1em;\n}\n\n.impac_ai_home_pg_result_text {\n  margin: 10px 0 16px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #6b6784;\n}\n\n.impac_ai_home_pg_result_line {\n  display: block;\n  height: 1px;\n  margin-bottom: 14px;\n  background: #e4dcf9;\n}\n\n.impac_ai_home_pg_result_pill {\n  align-self: flex-start;\n  padding: 5px 11px;\n  border-radius: 999px;\n  background: #fdecc2;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b4a00;\n}\n\n/* ---------- Buttons ---------- */\n\n.impac_ai_home_pg_actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.impac_ai_home_pg_btn_dark,\n.impac_ai_home_pg_btn_primary {\n  position: relative;\n  padding: 13px 24px;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;\n}\n\n.impac_ai_home_pg_btn_dark {\n  background: #55024f;\n  box-shadow: 0 10px 22px rgba(85, 2, 79, 0.28);\n}\n\n.impac_ai_home_pg_btn_primary {\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 12px 26px rgba(74, 26, 158, 0.34);\n}\n\n.impac_ai_home_pg_btn_dark:hover,\n.impac_ai_home_pg_btn_primary:hover {\n  transform: translateY(-3px);\n  filter: brightness(1.1);\n}\n\n.impac_ai_home_pg_btn_dark:active,\n.impac_ai_home_pg_btn_primary:active {\n  transform: translateY(0) scale(0.97);\n}\n\n.impac_ai_home_pg_btn_dark:focus-visible,\n.impac_ai_home_pg_btn_primary:focus-visible {\n  outline: 3px solid #f2a900;\n  outline-offset: 3px;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .impac_ai_home_pg_card {\n    grid-template-columns: 240px minmax(0, 1fr);\n  }\n\n  .impac_ai_home_pg_detail {\n    padding: 28px 28px 32px;\n  }\n\n  .impac_ai_home_pg_body {\n    grid-template-columns: minmax(0, 1fr) 220px;\n    gap: 18px;\n  }\n}\n\n/* sidebar turns into a sideways-scrolling pill row */\n@media (max-width: 820px) {\n  .impac_ai_home_pg_section {\n    padding: 56px 0 68px;\n  }\n\n  .impac_ai_home_pg_card {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .impac_ai_home_pg_tabs {\n    flex-direction: row;\n    gap: 8px;\n    padding: 12px;\n    overflow-x: auto;\n    border-right: 0;\n    border-bottom: 1px solid #e4dcf9;\n    scroll-snap-type: x proximity;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .impac_ai_home_pg_tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .impac_ai_home_pg_tab {\n    width: auto;\n    flex-shrink: 0;\n    padding: 9px 14px 9px 10px;\n    scroll-snap-align: center;\n  }\n\n  .impac_ai_home_pg_tab:hover {\n    transform: none;\n  }\n\n  .impac_ai_home_pg_tab_num {\n    display: none;\n  }\n\n  .impac_ai_home_pg_tab_label {\n    overflow: visible;\n  }\n\n  .impac_ai_home_pg_panel {\n    min-height: 0;\n  }\n}\n\n/* single column content */\n@media (max-width: 560px) {\n  .impac_ai_home_pg_container {\n    padding: 0 14px;\n  }\n\n  .impac_ai_home_pg_head {\n    margin-bottom: 28px;\n  }\n\n  .impac_ai_home_pg_subtitle {\n    font-size: 15px;\n  }\n\n  .impac_ai_home_pg_card {\n    border-radius: 16px;\n  }\n\n  .impac_ai_home_pg_detail {\n    padding: 22px 16px 26px;\n  }\n\n  .impac_ai_home_pg_panel_desc {\n    margin-bottom: 22px;\n    font-size: 15px;\n  }\n\n  .impac_ai_home_pg_body {\n    grid-template-columns: minmax(0, 1fr);\n    margin-bottom: 24px;\n  }\n\n  .impac_ai_home_pg_actions {\n    flex-direction: column;\n  }\n\n  .impac_ai_home_pg_btn_dark,\n  .impac_ai_home_pg_btn_primary {\n    width: 100%;\n    padding: 14px 20px;\n  }\n}\n\n/* ---------- Reduced motion ---------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_ai_home_pg_eyebrow,\n  .impac_ai_home_pg_title,\n  .impac_ai_home_pg_subtitle,\n  .impac_ai_home_pg_card,\n  .impac_ai_home_pg_tab,\n  .impac_ai_home_pg_tab::before,\n  .impac_ai_home_pg_point {\n    transition: opacity 0.2s ease !important;\n    transform: none !important;\n  }\n\n  .impac_ai_home_pg_panel,\n  .impac_ai_home_pg_step {\n    animation: impac_ai_home_pg_fade_only 0.25s ease both !important;\n    animation-delay: 0s !important;\n  }\n\n  @keyframes impac_ai_home_pg_fade_only {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n}\n\n\n/* ================= Impact explorer (Working Professionals) ================= */\n\n/* ============================================================\n   Impact explorer (Working Professionals) — shown inside HomeAiPage\n   Prefix: impac_ai_home_pg_x_ · no :root variables · no green\n   ============================================================ */\n\n.impac_ai_home_pg_x_section {\n  width: 100%;\n  padding: 72px 0 80px;\n  background: linear-gradient(180deg, #f8f4ff 0%, #f3edff 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  color: #0f0a2a;\n  overflow: hidden;\n}\n\n.impac_ai_home_pg_x_container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ---------- Header ---------- */\n\n.impac_ai_home_pg_x_head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 36px;\n}\n\n.impac_ai_home_pg_x_eyebrow {\n  margin-bottom: 14px;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_x_title {\n  max-width: 620px;\n  margin: 0 0 14px;\n  font-size: clamp(28px, 3.6vw, 44px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.015em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n.impac_ai_home_pg_x_subtitle {\n  max-width: 540px;\n  margin: 0;\n  font-size: 15.5px;\n  line-height: 1.65;\n  color: #5d5978;\n}\n\n/* scroll reveal */\n.impac_ai_home_pg_x_eyebrow,\n.impac_ai_home_pg_x_title,\n.impac_ai_home_pg_x_subtitle,\n.impac_ai_home_pg_x_card,\n.impac_ai_home_pg_x_note {\n  opacity: 0;\n  transform: translateY(26px);\n  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.impac_ai_home_pg_x_title {\n  transition-delay: 0.1s;\n}\n\n.impac_ai_home_pg_x_subtitle {\n  transition-delay: 0.2s;\n}\n\n.impac_ai_home_pg_x_card {\n  transform: translateY(40px) scale(0.98);\n  transition-delay: 0.3s;\n}\n\n.impac_ai_home_pg_x_note {\n  transition-delay: 0.6s;\n}\n\n.impac_ai_home_pg_x_in .impac_ai_home_pg_x_eyebrow,\n.impac_ai_home_pg_x_in .impac_ai_home_pg_x_title,\n.impac_ai_home_pg_x_in .impac_ai_home_pg_x_subtitle,\n.impac_ai_home_pg_x_in .impac_ai_home_pg_x_card,\n.impac_ai_home_pg_x_in .impac_ai_home_pg_x_note {\n  opacity: 1;\n  transform: none;\n}\n\n/* ---------- Card ---------- */\n\n.impac_ai_home_pg_x_card {\n  display: grid;\n  grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);\n  gap: 22px;\n  align-items: start;\n  padding: 22px;\n  border-radius: 20px;\n  border: 1px solid #e4dcf9;\n  background: linear-gradient(135deg, #f8f4ff 0%, #fff4ee 100%);\n  box-shadow: 0 28px 70px rgba(74, 26, 158, 0.12), 0 2px 8px rgba(74, 26, 158, 0.05);\n}\n\n/* ---------- List ---------- */\n\n.impac_ai_home_pg_x_list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.impac_ai_home_pg_x_item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 16px 10px 12px;\n  border: 1px solid #e4dcf9;\n  border-radius: 12px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: left;\n  color: #1c1538;\n  cursor: pointer;\n  isolation: isolate;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n/* purple fill that fades + scales in on the active item */\n.impac_ai_home_pg_x_item::before {\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  z-index: -1;\n  border-radius: 12px;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  opacity: 0;\n  transform: scale(0.94);\n  transition: opacity 0.35s ease, transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.impac_ai_home_pg_x_item:hover {\n  transform: translateX(4px);\n  border-color: #c9b6f2;\n  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.1);\n}\n\n.impac_ai_home_pg_x_item_active,\n.impac_ai_home_pg_x_item_active:hover {\n  transform: none;\n  border-color: transparent;\n  color: #ffffff;\n  box-shadow: 0 16px 30px rgba(74, 26, 158, 0.34);\n}\n\n.impac_ai_home_pg_x_item_active::before {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.impac_ai_home_pg_x_item:focus-visible {\n  outline: 3px solid #f2a900;\n  outline-offset: 2px;\n}\n\n.impac_ai_home_pg_x_item_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #f0e9ff;\n  color: #5a1fb5;\n  transition: background 0.3s ease, color 0.3s ease, transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.impac_ai_home_pg_x_item_icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.impac_ai_home_pg_x_item_active .impac_ai_home_pg_x_item_icon {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  transform: scale(1.08);\n}\n\n.impac_ai_home_pg_x_item_name {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.3;\n}\n\n.impac_ai_home_pg_x_item_value {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 800;\n  color: #3a14a0;\n  transition: color 0.3s ease;\n}\n\n.impac_ai_home_pg_x_item_active .impac_ai_home_pg_x_item_value {\n  color: #ffbf1f;\n}\n\n/* ---------- Detail ---------- */\n\n.impac_ai_home_pg_x_detail {\n  min-width: 0;\n  padding: 26px 28px 28px;\n  border: 1px solid #e4dcf9;\n  border-radius: 16px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8f4ff 100%);\n}\n\n/* zoom-out + fade that replays on every click */\n.impac_ai_home_pg_x_panel {\n  min-height: 420px;\n  transform-origin: 30% 15%;\n  animation: impac_ai_home_pg_x_zoom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes impac_ai_home_pg_x_zoom {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n    filter: blur(4px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n    filter: blur(0);\n  }\n}\n\n/* each block rises in, one after another */\n.impac_ai_home_pg_x_step {\n  animation: impac_ai_home_pg_x_rise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: calc(var(--s, 0) * 70ms + 120ms);\n}\n\n@keyframes impac_ai_home_pg_x_rise {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.impac_ai_home_pg_x_panel_head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.impac_ai_home_pg_x_panel_label {\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_x_panel_pill {\n  padding: 4px 11px;\n  border-radius: 999px;\n  background: #fdecc2;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b4a00;\n}\n\n.impac_ai_home_pg_x_figure {\n  margin-bottom: 22px;\n}\n\n.impac_ai_home_pg_x_big {\n  display: block;\n  font-size: clamp(48px, 6.2vw, 80px);\n  font-weight: 800;\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n  color: #3a14a0;\n  font-variant-numeric: tabular-nums;\n  min-height: 1.05em;\n  overflow-wrap: anywhere;\n}\n\n.impac_ai_home_pg_x_unit {\n  margin: 6px 0 0;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #1c1538;\n}\n\n/* ---------- Before / after bars ---------- */\n\n.impac_ai_home_pg_x_bars {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 20px;\n  padding: 18px 20px;\n  border: 1px solid #e4dcf9;\n  border-radius: 14px;\n  background: #ffffff;\n}\n\n.impac_ai_home_pg_x_bar_top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 7px;\n  font-size: 12.5px;\n}\n\n.impac_ai_home_pg_x_bar_label {\n  min-width: 0;\n  color: #3d3858;\n}\n\n.impac_ai_home_pg_x_bar_value {\n  flex-shrink: 0;\n  font-weight: 800;\n  color: #0f0a2a;\n}\n\n.impac_ai_home_pg_x_bar_value_accent {\n  color: #4a1a9e;\n}\n\n.impac_ai_home_pg_x_track {\n  height: 10px;\n  border-radius: 10px;\n  background: #f1ebfd;\n  overflow: hidden;\n}\n\n.impac_ai_home_pg_x_fill {\n  display: block;\n  width: var(--w, 0%);\n  height: 100%;\n  border-radius: 10px;\n  background: #d9ccf3;\n  /* grows from 0 each time the panel is re-keyed */\n  animation: impac_ai_home_pg_x_grow 1.1s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: calc(0.45s + var(--b, 0) * 0.2s);\n}\n\n.impac_ai_home_pg_x_fill_accent {\n  background: linear-gradient(90deg, #4a1a9e 0%, #6a1fc2 100%);\n}\n\n@keyframes impac_ai_home_pg_x_grow {\n  from {\n    width: 0;\n  }\n}\n\n/* ---------- Text ---------- */\n\n.impac_ai_home_pg_x_text {\n  max-width: 620px;\n  margin: 0 0 10px;\n  font-size: 14.5px;\n  line-height: 1.65;\n  color: #1c1538;\n}\n\n.impac_ai_home_pg_x_source {\n  margin: 0 0 22px;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: #6b6784;\n}\n\n.impac_ai_home_pg_x_btn {\n  padding: 13px 24px;\n  border: 0;\n  border-radius: 8px;\n  background: #55024f;\n  box-shadow: 0 10px 22px rgba(85, 2, 79, 0.28);\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;\n}\n\n.impac_ai_home_pg_x_btn:hover {\n  transform: translateY(-3px);\n  filter: brightness(1.12);\n  box-shadow: 0 14px 28px rgba(85, 2, 79, 0.34);\n}\n\n.impac_ai_home_pg_x_btn:active {\n  transform: translateY(0) scale(0.97);\n}\n\n.impac_ai_home_pg_x_btn:focus-visible {\n  outline: 3px solid #f2a900;\n  outline-offset: 3px;\n}\n\n.impac_ai_home_pg_x_note {\n  margin: 14px 0 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #6b6784;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .impac_ai_home_pg_x_card {\n    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n    gap: 18px;\n    padding: 18px;\n  }\n\n  .impac_ai_home_pg_x_detail {\n    padding: 22px 22px 24px;\n  }\n\n  .impac_ai_home_pg_x_item {\n    font-size: 13.5px;\n  }\n}\n\n/* list becomes a sideways-scrolling row above the detail */\n@media (max-width: 820px) {\n  .impac_ai_home_pg_x_section {\n    padding: 56px 0 64px;\n  }\n\n  .impac_ai_home_pg_x_card {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 16px;\n  }\n\n  .impac_ai_home_pg_x_list {\n    flex-direction: row;\n    gap: 8px;\n    margin: 0 -4px;\n    padding: 4px 4px 10px;\n    overflow-x: auto;\n    scroll-snap-type: x proximity;\n    scrollbar-width: none;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .impac_ai_home_pg_x_list::-webkit-scrollbar {\n    display: none;\n  }\n\n  .impac_ai_home_pg_x_item {\n    width: auto;\n    flex-shrink: 0;\n    gap: 10px;\n    padding: 9px 14px 9px 10px;\n    white-space: nowrap;\n    scroll-snap-align: center;\n  }\n\n  .impac_ai_home_pg_x_item:hover {\n    transform: none;\n  }\n\n  .impac_ai_home_pg_x_panel {\n    min-height: 0;\n  }\n}\n\n@media (max-width: 560px) {\n  .impac_ai_home_pg_x_container {\n    padding: 0 14px;\n  }\n\n  .impac_ai_home_pg_x_head {\n    margin-bottom: 26px;\n  }\n\n  .impac_ai_home_pg_x_subtitle {\n    font-size: 15px;\n  }\n\n  .impac_ai_home_pg_x_card {\n    padding: 12px;\n    border-radius: 16px;\n  }\n\n  .impac_ai_home_pg_x_detail {\n    padding: 18px 16px 22px;\n    border-radius: 14px;\n  }\n\n  .impac_ai_home_pg_x_bars {\n    padding: 14px 14px;\n  }\n\n  .impac_ai_home_pg_x_bar_top {\n    font-size: 12px;\n  }\n\n  .impac_ai_home_pg_x_btn {\n    width: 100%;\n    padding: 14px 20px;\n  }\n}\n\n/* ---------- Reduced motion ---------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_ai_home_pg_x_eyebrow,\n  .impac_ai_home_pg_x_title,\n  .impac_ai_home_pg_x_subtitle,\n  .impac_ai_home_pg_x_card,\n  .impac_ai_home_pg_x_note,\n  .impac_ai_home_pg_x_item,\n  .impac_ai_home_pg_x_item::before {\n    transition: opacity 0.2s ease !important;\n    transform: none !important;\n  }\n\n  .impac_ai_home_pg_x_panel,\n  .impac_ai_home_pg_x_step,\n  .impac_ai_home_pg_x_fill {\n    animation: impac_ai_home_pg_x_fade_only 0.25s ease both !important;\n    animation-delay: 0s !important;\n  }\n\n  @keyframes impac_ai_home_pg_x_fade_only {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n}\n\n\n/* ---- header tab switch: whole section fades + rises in ---- */\n.impac_ai_home_pg_swap {\n  animation: impac_ai_home_pg_swap_in 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes impac_ai_home_pg_swap_in {\n  from { opacity: 0; transform: translateY(16px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_ai_home_pg_swap {\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
